import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getDeviceById } from '../../services/DeviceService';
import { DeviceDetails } from '../../types/Devices';
import { FeaturesManagement } from '../../../featuresControl';

function useGetDeviceById(id:string, fleetId: string): UseQueryResult<DeviceDetails> {
  return useQuery(
    ['device', id, fleetId],
    async (): Promise<DeviceDetails> => getDeviceById(id, fleetId),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      refetchInterval: FeaturesManagement.productivity.refetchInterval,
      enabled: !!id,
    },
  );
}

export default useGetDeviceById;
